var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "components-input-demo-presuffix" },
    [
      _c(
        "a-input",
        {
          attrs: {
            placeholder: "请点击选择部门",
            readOnly: "",
            disabled: _vm.disabled
          },
          on: { click: _vm.openModal },
          model: {
            value: _vm.textVals,
            callback: function($$v) {
              _vm.textVals = $$v
            },
            expression: "textVals"
          }
        },
        [
          _c("a-icon", {
            attrs: { slot: "prefix", type: "cluster", title: "部门选择控件" },
            slot: "prefix"
          }),
          _vm.storeVals
            ? _c("a-icon", {
                attrs: { slot: "suffix", type: "close-circle", title: "清空" },
                on: { click: _vm.handleEmpty },
                slot: "suffix"
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }